import store from '@/store'
import { i18n } from '@/locale'
import { LocalizedText } from '@/entities/LocalizedText'
import snakecaseKeys from 'snakecase-keys'

function getTextValue (localizedTexts) {
  let value = null
  const defaultLanguageCode = (navigator.userLanguage || navigator.language) ?
    (navigator.userLanguage || navigator.language).split('-')[0] === 'es' ? 'es' :
      store.state.me.facility ?
        store.state.me.facility.defaultLanguageCode : 'en' : 'en'
  const localizedArray = snakecaseKeys(localizedTexts).map((text) => new LocalizedText(text))
  const configuredLocale = localizedArray.find((text) => { return text.languageCode === i18n.locale })
  if (configuredLocale) {
    value = configuredLocale.value
  } else {
    const defaultLocale = localizedArray.find((text) => { return text.languageCode === defaultLanguageCode })
    value = defaultLocale ? defaultLocale.value : (localizedArray[0].value || null)
  }
  return value
}

export {
  getTextValue,
}
